import { type ReactElement, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAuth } from '../lib/auth-context';

interface AnonRouteProps {
	children: ReactNode;
}

function AnonRoute({ children }: AnonRouteProps): ReactElement {
	const { isLoggedin } = useAuth();
	const { search } = useLocation();
	// ?next= lets a page send you to log in and come back (e.g. /oauth/authorize).
	// Only same-site paths, so it can't be used to bounce people off-site.
	const next = new URLSearchParams(search).get('next');
	const target = next && next.startsWith('/') && !next.startsWith('//') && !next.startsWith('/\\') ? next : '/profile';
	return !isLoggedin ? <>{children}</> : <Navigate to={target} replace />;
}

export default AnonRoute;
